import { render, staticRenderFns } from "./IndicatorsHistory.vue?vue&type=template&id=a488726c&scoped=true"
import script from "./IndicatorsHistory.vue?vue&type=script&lang=js"
export * from "./IndicatorsHistory.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsHistory.vue?vue&type=style&index=0&id=a488726c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a488726c",
  null
  
)

export default component.exports